import { useState } from "react";
import { Mail, CheckCircle2, Loader2, MapPin } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/Reveal";
import { submitContact, formatApiError } from "@/lib/auth";

export default function Contato() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [status, setStatus] = useState("idle");

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setStatus("loading");
        try {
            await submitContact(form);
            setStatus("done");
        } catch (err) {
            setStatus("idle");
            toast.error(formatApiError(err.response?.data?.detail));
        }
    };

    const inputCls = "w-full bg-paper border border-white/10 focus:border-gold/60 outline-none px-4 py-3.5 text-sm placeholder:text-slate-600 transition-colors";

    return (
        <main data-testid="contato-page" className="pt-28 md:pt-36 pb-20">
            <div className="max-w-5xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14">
                <Reveal>
                    <span className="text-xs uppercase tracking-[0.3em] text-gold font-medium">Contato</span>
                    <h1 className="font-serif text-4xl md:text-5xl tracking-tight mt-4 leading-tight">
                        Fale com a <span className="italic text-gold">redação.</span>
                    </h1>
                    <p className="mt-6 text-base text-slate-400 leading-relaxed max-w-md">
                        Sugestão de tema, correção, proposta de parceria ou patrocínio — lemos tudo.
                        Respondemos em até 2 dias úteis.
                    </p>
                    <div className="mt-10 flex flex-col gap-5">
                        <div className="flex items-center gap-3 text-sm text-slate-400">
                            <Mail size={16} className="text-gold" />
                            contato@investidorcomum.com.br
                        </div>
                        <div className="flex items-center gap-3 text-sm text-slate-400">
                            <MapPin size={16} className="text-gold" />
                            São Paulo, Brasil — redação 100% remota
                        </div>
                    </div>
                    <div className="mt-10 border border-white/10 bg-paper p-5 text-xs text-slate-500 leading-relaxed">
                        Para propostas comerciais, inclua nome da empresa, produto e orçamento estimado.
                        Só aceitamos parceiros alinhados aos nossos princípios editoriais.
                    </div>
                </Reveal>

                <Reveal delay={0.1}>
                    {status === "done" ? (
                        <div data-testid="contact-success" className="flex items-start gap-4 border border-gold/40 bg-gold/[0.05] p-8 mt-2">
                            <CheckCircle2 size={28} className="text-gold shrink-0" />
                            <div>
                                <p className="font-serif text-2xl">Mensagem enviada.</p>
                                <p className="text-sm text-slate-400 mt-2">Obrigado pelo contato. Respondemos em até 2 dias úteis.</p>
                            </div>
                        </div>
                    ) : (
                        <form data-testid="contact-form" onSubmit={submit} className="flex flex-col gap-4">
                            <div>
                                <label className="block text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Nome</label>
                                <input data-testid="contact-name-input" required minLength={2} value={form.name} onChange={set("name")} placeholder="Seu nome" className={inputCls} />
                            </div>
                            <div>
                                <label className="block text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">E-mail</label>
                                <input data-testid="contact-email-input" required type="email" value={form.email} onChange={set("email")} placeholder="seu@email.com.br" className={inputCls} />
                            </div>
                            <div>
                                <label className="block text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Mensagem</label>
                                <textarea data-testid="contact-message-input" required minLength={10} rows={7} value={form.message} onChange={set("message")} placeholder="Como podemos ajudar?" className={`${inputCls} resize-none`} />
                            </div>
                            <button
                                data-testid="contact-submit-button"
                                type="submit"
                                disabled={status === "loading"}
                                className="bg-gold text-ink font-medium px-8 py-4 text-sm hover:bg-golddark transition-colors disabled:opacity-60 flex items-center justify-center gap-2 mt-2"
                            >
                                {status === "loading" && <Loader2 size={15} className="animate-spin" />}
                                Enviar mensagem
                            </button>
                        </form>
                    )}
                </Reveal>
            </div>
        </main>
    );
}
